/**
 * Shared colour helpers for shallow-water beds and painted terrain. Phaser-free so the
 * terrain geometry builder (`src/sim/map/terrainGeometry.ts`) and the scene painters
 * fade a bed toward the seafloor the same way.
 */

import { MAX_WATER_DEPTH } from './map/types.ts';

/** How far the deepest bed fades toward the seafloor (0 = no fade, 1 = fully submerged). */
const BED_MAX_SINK = 0.72;

export function bedSinkFactor(depth: number): number {
  const t = Math.max(0, Math.min(1, depth / MAX_WATER_DEPTH));
  return t * BED_MAX_SINK;
}

export function mixColor(from: number, to: number, amount: number): number {
  const t = Math.max(0, Math.min(1, amount));
  const fr = (from >> 16) & 0xff;
  const fg = (from >> 8) & 0xff;
  const fb = from & 0xff;
  const tr = (to >> 16) & 0xff;
  const tg = (to >> 8) & 0xff;
  const tb = to & 0xff;
  const r = Math.round(fr + (tr - fr) * t);
  const g = Math.round(fg + (tg - fg) * t);
  const b = Math.round(fb + (tb - fb) * t);
  return (r << 16) | (g << 8) | b;
}
